import type {createBusinessRuntime} from '../../../packages/runtime/business-runtime.ts';
import type {
  SmtBusinessDayDispatchResult,
  SmtBusinessDayIntent,
  SmtBusinessDayViewModel,
} from '../../../packages/runtime/smt-business-day-contract.ts';

type BusinessRuntime = ReturnType<typeof createBusinessRuntime>;
type BusinessDayRuntime = Pick<BusinessRuntime, 'smtBusinessDay'>;

export interface SmtBusinessDayPortConfig {
  readonly operatorId: string;
  readonly now: () => string;
  readonly nextIdempotencyKey: () => string;
}

export interface SmtBusinessDayPort {
  readBusinessDay(): Promise<SmtBusinessDayViewModel | null>;
  dispatchBusinessDay(intent:SmtBusinessDayIntent, expectedRevision:number):Promise<SmtBusinessDayDispatchResult>;
}

export function createSmtBusinessDayPort(
  runtime:BusinessDayRuntime,
  config:SmtBusinessDayPortConfig,
):SmtBusinessDayPort {
  const request=()=>({actorId:config.operatorId,at:config.now()});

  return {
    async readBusinessDay(){
      return runtime.smtBusinessDay.snapshot(request());
    },
    async dispatchBusinessDay(intent,expectedRevision){
      return runtime.smtBusinessDay.dispatch(intent,{
        ...request(),
        expectedRevision,
        idempotencyKey:config.nextIdempotencyKey(),
      });
    },
  };
}
